import React from 'react';
import {
  Button,
  SvgExternalLink,
  Stack,
  Copy,
  Flex,
  Tooltip,
  IButtonProps,
  Box,
} from '@grubhubprod/gh-cookbook-react';
import { useFetchBalanceCreditApplicationUrl } from 'src/components/selfService/common/Balance/hooks/useFetchBalanceCreditApplicationUrl';
import { useBalanceAccountInfo } from 'src/components/selfService/common/Balance/hooks/useBalanceAccountInfo';

interface BalanceCreditApplicationButtonProps extends IButtonProps {
  text: string;
  unavailableTooltipText?: string;
  fullWidth?: boolean;
}

export function BalanceCreditApplicationButton({
  text,
  unavailableTooltipText,
  fullWidth,
  ...props
}: BalanceCreditApplicationButtonProps): JSX.Element {
  const { balanceOnboardingId, corpId } = useBalanceAccountInfo();
  const { balanceCreditApplicationUrl } = useFetchBalanceCreditApplicationUrl(
    balanceOnboardingId,
    corpId
  );

  const href = balanceCreditApplicationUrl?.creditApplicationUrl || null;
  const isButtonDisabled = !href;

  return (
    <Box style={{ width: fullWidth ? '100%' : 'auto' }}>
      <Tooltip
        disable={!isButtonDisabled}
        alignment="middle"
        content={
          <Copy variant="body">
            {unavailableTooltipText ||
              'Credit application is not available at this time'}
          </Copy>
        }
        position="below"
      >
        <Button
          variant="secondary"
          buttonSize="medium"
          target="_blank"
          as="a"
          href={href}
          disabled={isButtonDisabled}
          {...props}
        >
          <Flex alignItems="center" justifyContent="center" height="100%">
            <Stack x="x-sm" alignItems="center">
              {text}
            </Stack>
            <SvgExternalLink size="20px" />
          </Flex>
        </Button>
      </Tooltip>
    </Box>
  );
}
